import { Controller } from "@hotwired/stimulus";

/**
 * @class ChatController
 *
 * This controller is responsible for the chat
 *
 */
export default class extends Controller {
  static targets = ["messages"];

  connect() {
    this.scrollToBottom();
    addEventListener("turbo:before-stream-render", this.handleStreamRender);
  }

  disconnect() {
    removeEventListener("turbo:before-stream-render", this.handleStreamRender);
  }

  handleStreamRender = (event) => {
    window.setTimeout(() => {
      this.scrollToBottom(true);
    }, 500);
  };

  scrollToBottom(smoothScroll = false) {
    if (!this.hasMessagesTarget) return;

    this.messagesTarget.scrollTo({
      top: this.messagesTarget.scrollHeight,
      behavior: smoothScroll ? "smooth" : "auto",
    });
  }
}
